import { useQuery } from "@tanstack/react-query";

export function Factura() {
   const urlFact = process.env.REACT_APP_URL_DIR + "factura/tat";
   const token = localStorage.getItem("token");
   const { data } = useQuery({
      queryKey: ["Factura"],
      queryFn: () =>
         fetch(urlFact, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         }).then((res) => res.json())
   });

   return data;
}